export default __webpack_public_path__ + "static/media/container_bg.5f3302c0.png";